import cookie from 'js-cookie';
import localStorage from './localStorage';
const queryString = require('query-string')

const UA = window.navigator.userAgent;
const ua = parseUserAgent(UA);
const device = getDevice(ua.system);
const os = getOs(ua.system).name;
const osVersion = getOs(ua.system).version;

let parsed = queryString.parse(location.search);

// ~~~~~~~ 农行支付后跳转过来 => 重新拼接参数跳转 ~~~~~~~~
if (parsed && parsed.abcAppQs) {
  let abcAppQs = JSON.parse(decodeURIComponent(parsed.abcAppQs))
  let _qs = "?"
  for (let key in abcAppQs) {
    _qs += key + "=" + abcAppQs[key] + "&"
  }
  _qs = _qs.slice(0, -1)
  window.location.replace(location.origin + location.pathname + _qs)
}
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


const firstNoBack = parsed.firstNoBack || '0';

const partner = parsed.ptid || localStorage.get('ptid') || '';

//写入subptid(目前只有快应用过来的有子渠道参数), 后续过渡完之后去掉subptid
const subptid = parsed.subptid || '';
localStorage.set('ptid', decodeURIComponent(partner)); //写入ptid
if (subptid) {
  localStorage.set('subptid', decodeURIComponent(subptid));
} else {
  localStorage.remove('subptid');
}
localStorage.set('entryUrlParsed', parsed); //写入初始parsed
document.documentElement.className = partner;

const env = {
  ua, // { system, platform, extensions }
  device, // { model }
  os,
  osVersion,
  screen: {
    width: window.outerWidth,
    height: window.outerHeight,
    pixelRatio: window.devicePixelRatio
  },
  isFirstPageNavBack: firstNoBack !== '1',

  weixinJsReady: weixinJsReady,
  isWxwork: /wxwork/.test(UA),
  isWeixin: /micromessenger/i.test(UA),
  isWeixinMiniProgram: null, // 在weixinJsReady回调内判断
  // mp: null, // 微信小程序名

  isDingTalk: /dingtalk/i.test(UA),

  isPartner: !!partner,
  partner: partner,

  isNative: null,
  isQuickApp: null,
  quickappBrand: '',
  quickBrandSource: '', // 快应用详细渠道来源
  quickBrandSourceNum: null, // 快应用详细渠道来源数字编号

  appName: getAppName()
};

export default env;


function parseUserAgent(ua) {
  // https://en.wikipedia.org/wiki/User_agent
  // most Web browsers use a User-Agent string value as follows:
  // Mozilla/[version] ([system and browser information]) [platform] ([platform details]) [extensions]
  const re = /^.*? \(([^)]*)\) (.*?) \(.*\) (.*)$/;
  const result = re.exec(ua);

  if (result) {
    const [value, system, platform, extensions] = result;
    return {
      value,
      system,
      platform,
      extensions
    };
  } else {
    return {
      value: ua,
      system: 'unknown',
      platform: 'unknown',
      extensions: 'unknown'
    };
  }
}

function getOs(system) {
  let name = 'unknown';
  let version = '-';

  if (/(iphone|ipad|ipod)/i.test(system)) {
    name = 'ios'; // 公共参数都要小写的，就不规范了
    const r = /OS ([\d_]+)/.exec(system);
    if (r) {
      version = r[1].replace('_', '.');
    }
  } else if (/android/i.test(system)) {
    name = 'android';
    const r = /Android ([\d.]+)/.exec(system);
    if (r) {
      version = r[1];
    }
  }

  return {
    name,
    version
  };
}

function getDevice(system) {
  if (/iphone/i.test(system)) {
    return {
      model: 'iPhone'
    };
  } else if (/ipad/i.test(system)) {
    return {
      model: 'iPad'
    };
  } else if (/ipod/i.test(system)) {
    return {
      model: 'iPod'
    };
  } else if (/android/i.test(system)) {
    const parts = system.split(';');
    if (parts.length > 2) {
      return {
        model: parts[2].trim().split(' ')[0]
      };
    } else {
      return {
        model: 'Unknown'
      };
    }
  } else {
    return 'Unknown';
  }
}

// 获取当前运行平台或APP
if (env.isWeixin) {
  // env.mp = getFromQueryOrSession('mp');
  weixinJsReady(() => {
    env.isWeixinMiniProgram = window.__wxjs_environment === 'miniprogram';
  });
} else {
  //非微信端需清除wxsessinid
  localStorage.remove('wxsessionid');
  localStorage.remove('wxdepartment');

  // iOS 9.1的航班/高铁APP没有NativeAPI，此时只能当作普通浏览器对待
  // if (/^hbgj|^gtgj/.test(cookie.get('appName'))) {
  //   env.isNative = true;
  // }

  webviewJsReady(() => {
    env.isNative = true;
    // remove partner
    env.isPartner = false;
    env.partner = '';
    // cookie.remove('hlsource', { path: '/' })
  });
}


function queryQuickappBrandSource() {
  if (system.onmessage) { // 避免跟其他请求冲突
    setTimeout(queryQuickappBrandSource, 1000);
  } else {
    getQuickappBrandSource()
  }
}

function getQuickappBrandSource() {
  if (
    system &&
    system.postMessage &&
    typeof system.postMessage === "function"
  ) {
    system.onmessage = function(data) {
      console.log("system.onmessage getSourceInfo: ", data);
      let res = data ? JSON.parse(data) : null;
      if (res && res.result) {
        let result = res && res.result;
        env.quickBrandSource = result.brandSource || "";
        env.quickBrandSourceNum = result.brandSourceNum || null;
      }
      system.onmessage = null;
    };

    let message = JSON.stringify({
      jsonrpc: "2.0",
      id: 1,
      method: "Common.getSourceInfo",
      params: {}
    });

    system.postMessage(message);
  }
}

if (/ hap\//i.test(UA)) {
  const reg = new RegExp(/ com.hlth.gtgj.mini\/\d+(\.\d+){0,2} /i);
  let uaMatch = UA.match(reg)
  if (uaMatch && uaMatch.length) {
    uaMatch = uaMatch[0] ? uaMatch[0].trim() : "";
    let uaMatchSplit = uaMatch && uaMatch.split('/') ? uaMatch.split('/') : [];
    const version = uaMatchSplit && uaMatchSplit.length > 1 ? uaMatchSplit[1] : ""
    // 快应用 1.6版本及以上启用 快应用登录
    if (verGt('1.6', version)) {
      env.isQuickApp = true
      if (localStorage.get("authcode")) { // 1.6版本以上启动快应用登录, 本地数据需清除
        localStorage.remove("authcode")
        localStorage.remove("refreshcode")
      }
    }

    // 快应用 2.0版本及以上 参数从url中获取
    if (verGt('2.0', version)) {
      env.quickBrandSource = parsed.qaSource || "";
      env.quickBrandSourceNum = parsed.qaSourceNum || null;
    } else {
      setTimeout(queryQuickappBrandSource, 3000);
    }
  }

  let data = UA.split(' ')
  let hapInfo = data.filter(e => {
    return e.indexOf("hap") > -1
  });

  if (hapInfo && hapInfo.length && hapInfo[0]) {
    let _hap = hapInfo[0].split('/')
    env.quickappBrand = _hap && _hap.length && _hap[2] ? _hap[2].trim() : ''
    console.log('env.quickappBrand: ', env.quickappBrand)
  }
}

function getAppName() {
  // 这是获取appName的最直接方法，不需要调用nativeAPI等待异步结果
  const appName = cookie.get('appName');
  if (/hbgj/.test(appName)) {
    return 'hbgj';
  } else if (/gtgj/.test(appName)) {
    return 'gtgj';
  } else if (/hlcar/.test(appName)) {
    return 'hlcar';
  } else {
    return '';
  }
}

// 航班管家/高铁管家JS Bridge
function webviewJsReady(cb) {
  if (window.NativeAPI && window.NativeAPI.sendToNative) {
    cb();
  } else {
    document.addEventListener('WebViewJavaScriptBridgeReady', () => {
      if (window.NativeAPI && window.NativeAPI.sendToNative) {
        cb();
      }
    }, false);
  }
}

// 微信JS Bridge
function weixinJsReady(cb) {
  if (window.WeixinJSBridge && window.WeixinJSBridge.invoke) {
    cb();
  } else {
    document.addEventListener('WeixinJSBridgeReady', cb, false);
  }
}

/*检测版本是否大于等于
use 需求的版本
on  当前版本
return boolean
*/
function verGt(use, on) {
  use = ('' + use).split('.');
  on = ('' + on).split('.');
  for (var i = 0; i < use.length; i++) {
    on[i] = Number(on[i]) || 0;
    use[i] = Number(use[i]) || 0;
    if (on[i] < use[i]) {
      return false;
    } else if (on[i] > use[i]) {
      return true;
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/utils/env.js